"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResults = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var NoResults = function (_a) {
    var title = _a.title, description = _a.description;
    return react_1.default.createElement("div", { className: 'storybook-forms-new' },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: "mb-6" }, title),
        react_1.default.createElement(storybook_1.Texts.Primary, { lang: "mb-0" }, description));
};
exports.NoResults = NoResults;
exports.NoResults.propTypes = {
    /**
     * The title
     */
    title: prop_types_1.default.string,
    /**
     * The description
     */
    description: prop_types_1.default.string
};
